import TrackingAPI from "api/TrackingAPI";
import PaywallConsTool from "components/ai/tools/PaywallConsTool";
import styled from "styled-components";

const BlurOverlay = (props) => {
  const { url, onUnblurClick, scenario, game, dialog } = props;

  const analyticsData = {
    picture_url: url,
    config_name: scenario?.name,
    scenario_name: game?.name,
    dialogId: dialog?.id,
  };

  const handleUnblurClick = () => {
    onUnblurClick();
    TrackingAPI.trackEvent('remove_blur_click', analyticsData);
  };

  return (
    <PictureOverlay
      onClick={handleUnblurClick}
    >
      <div className="flex-column flex h-full w-full items-center justify-center text-center text-white">
        <PaywallConsTool />
      </div>
    </PictureOverlay>
  );
};

export default BlurOverlay;

const PictureOverlay = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  cursor: pointer;
  z-index: 2;
  width: 100%;
  height: calc(100% + 8px);
  backdrop-filter: blur(3vw);
  border-radius: 20px;
`;